import { HostListener, Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class IframeService {
  latestMessage = signal<string | null>(null);

  constructor() {
    addEventListener('message', (e) => {
      this.latestMessage.set(e.data);
    })
  }

  sendMessage(name: string) {
    window.top?.postMessage(name, '*');
  }
}
